/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition, aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- HEADER : STYLES --------------- ++++++++++ */
export default {
	header: {
		background: '#fff',
		boxShadow: replacePXinStringWithEM(`0px 1px 0px 0px rgba(6, 43, 117, 0.05), 0px 0px 24px 0px rgba(172, 217, 251, 0.2)`),
		display: 'flex',
		flex: 'none',
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		alignItems: 'center',
		minHeight: pxToEm(96),
		padding: replacePXinStringWithEM(`16px 30px`),
		position: 'relative',
		zIndex: '2',
		extend: hoverTransition(),
		// opacity: '0',
  //       animationName: 'fadeInDown',
  //       animationDuration: aniSpeed,
  //       animationFillMode: 'forwards',
		'& .asidetoggle': {
			marginRight: pxToEm(16)
		},
		'& .headercontent': {
			flex: '1'
		},
		'&:hover': {
			boxShadow: replacePXinStringWithEM(`0px 1px 0px 0px rgba(6, 43, 117, 0.05), 0px 0px 24px 0px rgba(172, 217, 251, 0.5)`)
		},
		'&.sidebarOpen': {
			'&-true': {
				'& .asidetoggle': {
					display: 'none'
				}
			}
		}
	}
}; 